<a mdbRipple outline="true" mdbWavesEffect class="p-md-2 text-dark waves-effect" (click)="showAddresses($event)"
  ><span class="pull-right"><i class="fas fa-edit"></i> Pick Address</span></a
>
<div
  mdbModal
  #selectAddressModal="mdbModal"
  class="modal fade"
  tabindex="-10"
  role="dialog"
  aria-labelledby="myBasicModalLabel"
  aria-hidden="true"
  [config]="{
    ignoreBackdropClick: true,
    animated: true,
    backdrop: true
  }"
>
  <div class="modal-dialog modal-lg modal-dialog-centered" role="document">
    <div class="modal-content">
      <div class="modal-header">
        <button
          type="button"
          class="close pull-right align-middle"
          aria-label="Close"
          (click)="selectAddressModal.hide()"
        >
          <span aria-hidden="true">×</span>
        </button>
        <h3 class="modal-title w-100" id="myModalLabel">
          <i class="fas fa-house-user"></i>
          Pick a {{ addressType }} address
        </h3>
      </div>
      <div class="modal-body">
        <div class="dialog-body">
          <div class="backdrop" *ngIf="isWaiting">
            <div class="spinner-border" role="status">
              <span class="sr-only">Loading...</span>
            </div>
          </div>
          <div *ngIf="selectAddressModel" class="row">
            <div class="col-lg-4" *ngFor="let adr of selectAddressModel.AddressList">
              <app-address-view [address]="adr"></app-address-view>
              <div>
                <button mdbRipple type="button" class="btn btn-primary" (click)="selectAddress(adr)">
                  Select this address
                </button>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>
